<!-- 储值卡扣费流水上报接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/comUpwardStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "cmd": "reportPreCarIn",
          "enterCarLicenseNumber": "渝A90789",
          "enterCarLicenseType": 0,
          "enterChannelCode": "0001",
          "enterChargeGroupCode": "",
          "enterTime": "20170929174603",
          "parkCode": "2KM43Y461"
        },
        responseCode: {
          "data": {}, "message": "业务成功", "resultCode": 0, "status": 1
        },
        infoData: {
          explain: "智慧停车开放平台主动上报通过智慧停车公众号缴费的账单信息到第三方接入系统",
          urlPattern: this.commonUrls.third + "reportYdtParkFee",
          precondition: "无",
          fitSystem: "VEMS传统停车场，云停车场",
          pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
          frequency: "实时触发",
          Q_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号'},
              {info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车流水'},
              {info1: 'carLicenseNumber', info2: '是', info3: 'String', info4: '车牌号'},
              {info1: 'phone', info2: '是', info3: 'String', info4: '手机号（支付账户）'},
              {info1: 'payMode', info2: '是', info3: 'int', info4: '支付方式，0:微信支付,1:支付宝,2:余额支付,3:余额支付,4:银联'},
              {info1: 'payOrigin', info2: '是', info3: 'int', info4: '支付来源，请查看附件'},
              {info1: 'payModeRemark', info2: '否', info3: 'String', info4: '支付方式备注'},
              {info1: 'payOriginRemark', info2: '否', info3: 'String', info4: '支付来源备注'},
              {info1: 'actPayCharge', info2: '是', info3: 'Decimal', info4: '实际支付金额'},
              {
                info1: 'couponList', info2: '是', info3: 'JSONArray', info4: '支付优惠列表。couponOrigin和couponType的组合决定优惠的类型：\
                                                                    couponOrigin=2 couponType=0 第三方积分；\
                                                                    couponOrigin=2 couponType=2 第三方优惠（缴费带券，v1.12.0版本起）,v1.12.0版本之前与停车场线上活动优惠重复使用0、3；\
                                                                    couponOrigin=2 couponType=3 第三方优惠；\
                                                                    couponOrigin=0 couponType=0 本地优惠（vems人工优惠）；\
                                                                    couponOrigin=0 couponType=1 电子券优惠；\
                                                                    couponOrigin=0 couponType=2 vems计费系数（计费规则补充不体现在账单中）；\
                                                                    couponOrigin=0 couponType=3 停车场线上活动优惠；\
                                                                    couponOrigin=1 couponType=1 城市运营券优惠；\
                                                                    couponOrigin=1 couponType=2 城市运营积分；'
              },
              {info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识'},
            ]
          }, {
            titleName: 'couponList',
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'couponOrigin', info2: '是', info3: 'int', info4: '优惠来源，0停车场 1智慧停车 2第三方定义优惠'},
              {
                info1: 'couponType',
                info2: '是',
                info3: 'int',
                info4: '与临停缴费上报中的couponType相同。优惠类型：具体对应优惠来源（couponOrigin）所对应的类型, 停车场类型：0本地优惠 1电子券优惠 2vems计费系数 3停车场线上活动优惠，智慧停车类型：1城市运营券优惠 2城市运营积分，第三方类型（针对智慧停车开放平台）：0第三方积分 2第三方优惠（缴费带券） 3第三方优惠'
              },
              {
                info1: 'reliefType',
                info2: '否',
                info3: 'int',
                info4: '减免类型，券类型(0:免费券,1:金额扣减券,费减免固定金额结算,2:金额折扣券,车费折扣减免结算,3:金额固定值券,车费按券的固定值结算,4:时间券,时间减免后再按车费结算,5:不同计价券,按不同计价规则车费结算)'
              },
              {info1: 'couponName', info2: '否', info3: 'String', info4: '优惠名称'},
              {info1: 'couponCode', info2: '是', info3: 'String', info4: '优惠券的编码'},
              {info1: 'couponValue', info2: '是', info3: 'Decimal', info4: '实际的抵扣金额'},
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: []
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{tableHead: '状态码', tdName: 'info1'}, {tableHead: '说明', tdName: 'info2'}],
            td: []
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/reportYdtParkFee.vue